import { useScrollReveal } from "@/hooks/useScrollReveal";

const StorySection = () => {
  const { ref: textRef, isVisible: textVisible } = useScrollReveal();
  const { ref: statsRef, isVisible: statsVisible } = useScrollReveal();

  return (
    <section id="story" className="py-16 lg:py-20 bg-primary text-primary-foreground">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <div
            ref={textRef}
            className={`transition-all duration-700 ease-out ${
              textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            <p className="text-luxury text-primary-foreground/70 mb-4">Our Story</p>
            <h2 className="heading-section mb-8">
              Born from a
              <br />
              <span className="italic opacity-80">Love of Travel</span>
            </h2>
            <p className="text-body text-primary-foreground/80 mb-8 max-w-2xl mx-auto">
              Founded by fragrance enthusiasts who understood that your signature
              scent shouldn't stay behind. We created Luxe Lords for those who
              believe that details matter—even on the go.
            </p>
            <p className="text-body text-primary-foreground/80 max-w-2xl mx-auto">
              Each atomizer is crafted with the same attention to detail you'd
              expect from the finest Premium Vegan leather goods. Because your fragrance deserves
              an equally refined vessel.
            </p>
          </div>

          {/* Stats */}
          <div
            ref={statsRef}
            className="grid grid-cols-3 gap-8 mt-10 pt-10 border-t border-primary-foreground/20"
          >
            {[
              { value: "8", label: "Curated Colours" },
              { value: "10ml", label: "Capacity" },
              { value: "∞", label: "Refillable" },
            ].map((stat, index) => (
              <div
                key={stat.label}
                className={`transition-all duration-500 ease-out ${
                  statsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                }`}
                style={{ transitionDelay: `${index * 150}ms` }}
              >
                <p className="font-serif text-4xl lg:text-5xl text-primary-foreground mb-2">
                  {stat.value}
                </p>
                <p className="text-luxury text-xs text-primary-foreground/70">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
